import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { redirectToSanitizedUrl } from '../../../../../../ui-kitchen/src/utils/sanitizeTargetUrl';
import { handleMktAnalytics, isDevicePixelRatio2x, validateImageFileFormat } from '../../AmexMarketingUtils/AmexUtils';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import './AmexGDAB2BDinerExperience.scss';

const AmexGDAB2BDinerExperience = (
  {
    baseRequestUrl,
    getDinerExperienceComponentStatus,
    Analytics,
    matchMedia,
    dinerExperienceConfig: {
      images: {
        desktop: desktopImg = {},
        mobile: mobileImg = {},
      } = {},
      cta: {
        label: ctaLabel = '',
        url: ctaUrl = '',
      } = {},
      section_id: sectionId,
      subtitle,
      title,
      text,
    } = {},
  }
) => {
  if (!title) {
    getDinerExperienceComponentStatus(false);
    return null;
  }
  const imgPath = `${baseRequestUrl}AmexGDAB2B/images/DinerExperience/`;
  const imageType = matchMedia.lg ? desktopImg : mobileImg;
  const imageName = isDevicePixelRatio2x() ? imageType?.retina : imageType?.regular;
  const image = validateImageFileFormat(imageName);

  const sanitizedTitle = sanitizeString(title);
  const sanitizedSubtitle = sanitizeString(subtitle);
  const sanitizedText = sanitizeString(text);

  return (
    <section className="AmexGDAB2BDinerExperience">
      <div className="container">
        <div className="AmexGDAB2BDinerExperience__wrapper">
          <h2
            id={sectionId}
            className="AmexGDAB2BDinerExperience__title"
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: sanitizedTitle,
            }}
          />
          {subtitle && (
            <p
              className="AmexGDAB2BDinerExperience__subtitle"
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedSubtitle,
              }}
            />
          )}
          <div className="AmexGDAB2BDinerExperience__img">
            {imageName && (
              <img
                className="AmexGDAB2BDinerExperience__img--resy"
                src={`${imgPath}${image}`}
                alt=""
              />
            )}
          </div>
          <p className="AmexGDAB2BDinerExperience__text">
            <span
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedText,
              }}
            />
            {(ctaLabel && ctaUrl) && (
              <Link
                className="AmexGDAB2BDinerExperience__cta"
                onClick={() => {
                  const extraParam = {
                    action_name: 'Diner Experience - Click',
                  };
                  handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
                  redirectToSanitizedUrl(ctaUrl);
                }}
              >
                {ctaLabel}
              </Link>
            )}
          </p>
        </div>
      </div>
    </section>
  );
};

AmexGDAB2BDinerExperience.propTypes = {
  baseRequestUrl: PropTypes.string.isRequired,
  getDinerExperienceComponentStatus: PropTypes.func.isRequired,
  dinerExperienceConfig: PropTypes.shape({
    images: PropTypes.shape({
      desktop: PropTypes.shape({}).isRequired,
      mobile: PropTypes.shape({}).isRequired,
    }).isRequired,
    cta: PropTypes.shape({
      label: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      event_tag: PropTypes.string.isRequired,
    }).isRequired,
    section_id: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    ipadLandscape: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
};

export default AmexGDAB2BDinerExperience;
